import React from 'react';

import { useModal } from 'context/ModalContext';
import { useTranslation } from 'react-i18next';

const AuthButtons = () => {
  const { t } = useTranslation('common');
  const { openModal, MODAL_TYPES } = useModal();

  const openLoginModal = () => {
    openModal(MODAL_TYPES.LOGIN);
  };

  return (
    <div className="flex items-center gap-3">
      <button
        className="cursor-pointer whitespace-nowrap rounded-md px-3 py-1.5 text-b3 font-semibold hover:bg-[#F6F6F6]"
        onClick={() => {
          window.dataLayer?.push({
            event: 'click_room_listing',
            section: 'Header',
          });
          window.open('https://admin.checkmatekorea.com/login', '_blank');
        }}
      >
        무료로 방 등록하기 ↗
      </button>

      <button
        className="cursor-pointer whitespace-nowrap rounded-md px-3 py-1.5 text-b3 font-semibold hover:bg-[#F6F6F6]"
        onClick={() => {
          window.dataLayer?.push({
            event: 'click_menu',
            menu: 'login',
            section: 'Header',
          });
          openLoginModal();
        }}
      >
        {t('navigation.login')}
      </button>
    </div>
  );
};

export default AuthButtons;
